import React from 'react';
import { Link } from 'react-router-dom';
import { AdminLayout } from '../components/admin/AdminLayout';
import { CarIcon, PlusIcon, TrendingUpIcon } from 'lucide-react';
export function AdminDashboard() {
  // Mock stats - in real app, calculate from actual data
  const stats = {
    totalVehicles: 12,
    newVehicles: 8,
    usedVehicles: 4,
    totalValue: '$2,485,000'
  };
  return <AdminLayout data-id="element-209">
      <div className="p-8" data-id="element-210">
        <div className="mb-8" data-id="element-211">
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-212">Dashboard</h1>
          <p className="text-gray-400" data-id="element-213">Overview of your car inventory</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-214">
          <div className="bg-[var(--color-black-rich)] border border-gray-800 rounded-lg p-6" data-id="element-215">
            <div className="flex items-center justify-between mb-4" data-id="element-216">
              <div className="p-3 bg-[var(--color-gold)]/10 rounded-lg" data-id="element-217">
                <CarIcon className="w-6 h-6 text-[var(--color-gold)]" aria-hidden="true" data-id="element-218" />
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-1" data-id="element-219">Total Vehicles</p>
            <p className="text-3xl font-bold text-white" data-id="element-220">
              {stats.totalVehicles}
            </p>
          </div>

          <div className="bg-[var(--color-black-rich)] border border-gray-800 rounded-lg p-6" data-id="element-221">
            <div className="flex items-center justify-between mb-4" data-id="element-222">
              <div className="p-3 bg-emerald-500/10 rounded-lg" data-id="element-223">
                <TrendingUpIcon className="w-6 h-6 text-emerald-400" aria-hidden="true" data-id="element-224" />
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-1" data-id="element-225">New Vehicles</p>
            <p className="text-3xl font-bold text-white" data-id="element-226">{stats.newVehicles}</p>
          </div>

          <div className="bg-[var(--color-black-rich)] border border-gray-800 rounded-lg p-6" data-id="element-227">
            <div className="flex items-center justify-between mb-4" data-id="element-228">
              <div className="p-3 bg-blue-500/10 rounded-lg" data-id="element-229">
                <CarIcon className="w-6 h-6 text-blue-400" aria-hidden="true" data-id="element-230" />
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-1" data-id="element-231">Used Vehicles</p>
            <p className="text-3xl font-bold text-white" data-id="element-232">
              {stats.usedVehicles}
            </p>
          </div>

          <div className="bg-[var(--color-black-rich)] border border-gray-800 rounded-lg p-6" data-id="element-233">
            <div className="flex items-center justify-between mb-4" data-id="element-234">
              <div className="p-3 bg-[var(--color-gold)]/10 rounded-lg" data-id="element-235">
                <TrendingUpIcon className="w-6 h-6 text-[var(--color-gold)]" aria-hidden="true" data-id="element-236" />
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-1" data-id="element-237">Total Inventory Value</p>
            <p className="text-3xl font-bold text-white" data-id="element-238">{stats.totalValue}</p>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="bg-[var(--color-black-rich)] border border-gray-800 rounded-lg p-6" data-id="element-239">
          <h2 className="text-xl font-bold text-white mb-4" data-id="element-240">Quick Actions</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-241">
            <Link to="/admin/vehicles" className="flex items-center gap-4 p-4 bg-[var(--color-black-soft)] rounded-lg hover:bg-gray-800 transition-colors group" data-id="element-242">
              <div className="p-3 bg-[var(--color-gold)]/10 rounded-lg group-hover:bg-[var(--color-gold)]/20 transition-colors" data-id="element-243">
                <PlusIcon className="w-6 h-6 text-[var(--color-gold)]" aria-hidden="true" data-id="element-244" />
              </div>
              <div data-id="element-245">
                <p className="text-white font-semibold" data-id="element-246">Add New Vehicle</p>
                <p className="text-gray-400 text-sm" data-id="element-247">
                  Add a vehicle to your inventory
                </p>
              </div>
            </Link>

            <Link to="/admin/vehicles" className="flex items-center gap-4 p-4 bg-[var(--color-black-soft)] rounded-lg hover:bg-gray-800 transition-colors group" data-id="element-248">
              <div className="p-3 bg-[var(--color-gold)]/10 rounded-lg group-hover:bg-[var(--color-gold)]/20 transition-colors" data-id="element-249">
                <CarIcon className="w-6 h-6 text-[var(--color-gold)]" aria-hidden="true" data-id="element-250" />
              </div>
              <div data-id="element-251">
                <p className="text-white font-semibold" data-id="element-252">Manage Vehicles</p>
                <p className="text-gray-400 text-sm" data-id="element-253">
                  View and edit your inventory
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </AdminLayout>;
}